export interface InsuranceAgentRecord {
  insuranceAgentId?: number;
  name: string;
  email: string;
  phone: string;
  address: string;
  agency?: string;
}

export interface HighlightedEmail {
  pre: string;
  mid: string;
  post: string;
}

export const stemEmail = (email: string): string =>
  (email || '').replace(/\.[a-z]+$/i, '').toLowerCase();

export const matchAgents = (
  agents: InsuranceAgentRecord[],
  query: string
): InsuranceAgentRecord[] => {
  const q = (query || '').trim().toLowerCase();
  if (!q) return agents;
  return agents.filter(agent =>
    `${stemEmail(agent.email)} ${agent.name} ${agent.agency ?? ''}`
      .toLowerCase()
      .includes(q)
  );
};

export const highlightEmail = (email: string, query: string): HighlightedEmail => {
  const q = (query || '').trim().toLowerCase();
  const i = q ? stemEmail(email).indexOf(q) : -1;
  return i < 0
    ? { pre: email, mid: '', post: '' }
    : {
      pre: email.slice(0, i),
      mid: email.slice(i, i + q.length),
      post: email.slice(i + q.length),
    };
};

export const getInitials = (name: string): string =>
  (name || '')
    .split(' ')
    .filter(Boolean)
    .map(word => word[0])
    .join('')
    .toUpperCase();
